var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReapitConsoleLogoIcon = function SvgReapitConsoleLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEBED",
    d: "M0 0h40v40H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC9615",
    d: "m10.408 14.797 2.396 1.577v3.365c0 1.854.034 3.365.067 3.365s1.11-.71 2.386-1.577l2.319-1.566v-6.74H8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C11540",
    d: "M17.909 20.15c0 .022 1.02.71 2.274 1.532l2.275 1.477V30l2.363-1.6 2.352-1.598.034-3.343.022-3.354h-4.66c-2.563 0-4.66.023-4.66.045"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#96C1C1",
    d: "M22.68 10.044c0 .023 1.054.733 2.33 1.566l2.33 1.522v6.751L32 16.774V10h-4.66c-2.563 0-4.66.022-4.66.044"
  })));
};
export { SvgReapitConsoleLogoIcon as ReactComponent };